import $ from 'jquery';

export default {
  template: `
    <div class="sample-request-button-wrap">
      <button type="button" class="primary button" @click="addToCart">
        <ui-progress-circular v-if="acting" :size="17" :indeterminate="true" />
        <span v-else>Request a Sample</span>
      </button>
    </div>
  `,

  props: {
    requestUrl: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      acting: false,
    };
  },

  methods: {
    addToCart() {
      this.acting = true;

      if (this.xhr) {
        this.xhr.abort();
      }

      this.xhr = $.ajax({
        type: 'POST',
        url: this.requestUrl,
      }).done((resp) => {
        window.location = resp.cartUrl;
      }).always(() => {
        this.acting = false;
      });
    },
  },

  created() {
    this.xhr = null;
  },
};
